import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CallMergeIcon from '@mui/icons-material/CallMerge';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import EditIcon from '@mui/icons-material/Edit';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FilterListIcon from '@mui/icons-material/FilterList';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import GroupIcon from '@mui/icons-material/Group';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import NotesIcon from '@mui/icons-material/Notes';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import RedoIcon from '@mui/icons-material/Redo';
import SummarizeIcon from '@mui/icons-material/Summarize';
import UndoIcon from '@mui/icons-material/Undo';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AiSparklesIcon, { AutoFixHighDirectionIcon } from '../components/icons/AiSparklesIcon';
import TreeAssistantIcon from '../components/icons/TreeAssistantIcon';

const iconSx = { fontSize: 'small' as const };

/** Icons aligned with category tree context menu and main toolbar. */
export const WORKSPACE_MENU_ICONS: Record<string, React.ReactNode> = {
  undo: <UndoIcon sx={iconSx} />,
  redo: <RedoIcon sx={iconSx} />,
  cut: <ContentCutIcon sx={iconSx} />,
  copy: <ContentCopyIcon sx={iconSx} />,
  paste: <ContentPasteIcon sx={iconSx} />,
  'add-category': <AddIcon sx={iconSx} />,
  'rename-category': <DriveFileRenameOutlineIcon sx={iconSx} />,
  'delete-category': <DeleteIcon sx={iconSx} />,
  split: <CallSplitIcon sx={iconSx} />,
  group: <CallMergeIcon sx={iconSx} />,
  merge: <JoinFullIcon sx={iconSx} />,
  flatten: <KeyboardDoubleArrowUpIcon sx={iconSx} />,
  'collect-branch': <ViewListOutlinedIcon sx={iconSx} />,
  'import-subtree': <DriveFolderUploadIcon sx={iconSx} />,
  'move-category-up': <ArrowUpwardIcon sx={iconSx} />,
  'move-category-down': <ArrowDownwardIcon sx={iconSx} />,
  'duplicate-as-document': <FileCopyIcon sx={iconSx} />,
  'add-content': <AddIcon sx={iconSx} />,
  'edit-content': <EditIcon sx={iconSx} />,
  'adjust-text': <NotesIcon sx={iconSx} />,
  'delete-content': <DeleteIcon sx={iconSx} />,
  'move-content-up': <ArrowUpwardIcon sx={iconSx} />,
  'move-content-down': <ArrowDownwardIcon sx={iconSx} />,
  'invert-content-selection': <SwapHorizIcon sx={iconSx} />,
  'rename-subcase': <EditNoteIcon sx={iconSx} />,
  'subcase-groups': <GroupIcon sx={iconSx} />,
  'content-filter': <FilterListIcon sx={iconSx} />,
  'structure-categories': <AutoFixHighDirectionIcon direction="north" variant="menu" />,
  'add-matching-content': <PlaylistAddOutlinedIcon sx={iconSx} />,
  'compare-content': <CompareArrowsIcon sx={iconSx} />,
  'category-ai-report': <SummarizeIcon sx={iconSx} />,
  'ask-ai': <AiSparklesIcon sx={iconSx} />,
  'tree-assistant': <TreeAssistantIcon sx={iconSx} />,
  find: <FindInPageIcon sx={iconSx} />,
  'show-sub-tree': <VisibilityIcon sx={iconSx} />,
};

export function workspaceMenuIconFor(id: string): React.ReactNode | undefined {
  return WORKSPACE_MENU_ICONS[id];
}
